import React from 'react';
import { Link } from 'react-router-dom';
import WorkGrid from '@/components/landing/WorkGrid';
import { featuredWork } from '@/data/redesigns';

/**
 * EXAMPLES on the homepage. One grid, one title, no split between real client
 * sites and studies we set ourselves. Every card clicks through to its own
 * page, and the ones that are running link out from there.
 */
export default function SelectedWork() {
  return (
    <section className="al-section bg-[#F8F4EC] border-t border-[#0A1A2F]/10">
      <div className="al-container">
        <div className="al-eyebrow text-[#8C6C2D]"><span aria-hidden />Examples</div>

        <div className="mt-9 flex flex-wrap items-end justify-between gap-8">
          <h2 className="max-w-[15ch] font-serif text-[clamp(2.3rem,5.5vw,4.4rem)] leading-[1.02] tracking-[-0.03em]">
            What it looks like <em className="font-normal text-[#8C6C2D]">when it is done.</em>
          </h2>
          <Link
            to="/work"
            className="group inline-flex items-center gap-3 pb-2 text-[12px] font-semibold uppercase tracking-[0.16em] text-[#8C6C2D] transition-colors hover:text-[#0A1A2F]"
          >
            All examples
            <span aria-hidden className="transition-transform duration-300 group-hover:translate-x-1">→</span>
          </Link>
        </div>

        <div className="mt-16">
          <WorkGrid studies={featuredWork} />
        </div>
      </div>
    </section>
  );
}
